import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    RESEND_API_KEY: z.string().min(1, "RESEND_API_KEY is required"),
    RESEND_FROM_EMAIL: z.string().email("RESEND_FROM_EMAIL is required"),
    RESEND_TO_EMAIL: z.string().email("RESEND_TO_EMAIL is required"),
  },
  client: {
    NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN: z.string(),
    NEXT_PUBLIC_STORYBLOK_PREVIEW: z.string(),
    NEXT_PUBLIC_DOMAIN: z.string(),
    NEXT_PUBLIC_COMPANY_NAME: z.string(),
    NEXT_PUBLIC_COMPANY_DESCRIPTION: z.string(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().url(),
  },
  runtimeEnv: {
    RESEND_API_KEY: process.env.RESEND_API_KEY,
    RESEND_FROM_EMAIL: process.env.RESEND_FROM_EMAIL,
    RESEND_TO_EMAIL: process.env.RESEND_TO_EMAIL,
    NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN:
      process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN,
    NEXT_PUBLIC_STORYBLOK_PREVIEW: process.env.NEXT_PUBLIC_STORYBLOK_PREVIEW,
    NEXT_PUBLIC_DOMAIN: process.env.NEXT_PUBLIC_DOMAIN,
    NEXT_PUBLIC_COMPANY_NAME: process.env.NEXT_PUBLIC_COMPANY_NAME,
    NEXT_PUBLIC_COMPANY_DESCRIPTION:
      process.env.NEXT_PUBLIC_COMPANY_DESCRIPTION,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  },
});
